import { LandingPageView } from '../pages/landing/LandingPageView';
export const Landing = LandingPageView;